import { useBreakpoint, useLanguage } from '@pharmac-extranet/shared'
import { PharmacButton, PharmacH1, PharmacText } from '@pharmac/ui'
import { ExtranetGradient } from '../../components/extranet/ExtranetGradient'
import { ExtranetWrapper } from '../../components/extranet/ExtranetWrapper'
import { useAuthenticationContext } from '../../features/authentication/useAuthentication'

export const NotLoggedInView = () => {
  const authHook = useAuthenticationContext()
  const { minDesktop } = useBreakpoint()
  const { t } = useLanguage()

  return (
    <ExtranetGradient>
      <ExtranetWrapper>
        <PharmacH1
          marginLargeTop
          color="white"
        >
          {t('extranet:unauthorized.welcome')}
        </PharmacH1>
        <PharmacButton
          marginLargeVertical
          fullWidth={minDesktop}
          onClick={() => authHook.doLogin()}
        >
          <PharmacText
            paddingSmall
            style={{ fontSize: '24px' }}
          >
            {t('common:login')}
          </PharmacText>
        </PharmacButton>
      </ExtranetWrapper>
    </ExtranetGradient>
  )
}
